(function () {
  'use strict';

  angular
    .module('specsguardApp')
    .controller('sgFormWithInfoController', sgFormWithInfoController);

  sgFormWithInfoController.$inject = ['$scope', 'Labels', 'EditorConfig', '$timeout'];

  function sgFormWithInfoController($scope, Labels, EditorConfig, $timeout) {

    const vm = this;

    //holder for formdata
    vm.model = {};

    vm.click = function (index) {
      vm.buttonsCb({index: index});
    };

    vm.LABELS = Labels;

    vm.$onInit = () => {
      //wrap in timeout so the form object is initialized
      $timeout(function () {
        if (vm.form && vm.form.ref) {
          vm.form.ref = vm.infoForm;
        } else if (vm.form) {
          vm.form = vm.infoForm;
        }
      })
    };

    function sendOnChange(value, item, key) {
      const onChange = vm.fieldsObj[key].onChange;
      onChange ? onChange({
        value,
        item,
        key,
        form: vm.infoForm
      }) : null;
    }

    function toggleImageSelection(item, key) {
      if (item.selected) {
        item.selected = false;
        return;
      }

      item.selected = true;

      if (!vm.multi) {
        vm.fieldsObj[key].options.forEach((opt) => {
          if (opt !== item) {
            opt.selected = false;
          }
        });
      }
    }

    vm.setImage = (value, item, key) => {
      const imgArr = vm.targetObj[key];

      if (imgArr && imgArr.includes(value)) {
        const imgIdx = imgArr.findIndex((img) => img === value);
        vm.targetObj[key] = [...imgArr.slice(0, imgIdx), ...imgArr.slice(imgIdx + 1)];
      } else if (!imgArr || imgArr.length === 0 || (imgArr.length === 1 && !vm.multi)) {
        vm.targetObj[key] = [value];
      } else if (vm.multi) {
        imgArr.push(value);
      }

      toggleImageSelection(item, key);
      sendOnChange(value, item, key);
    };

    vm.setValue = (value, item, key) => {
      vm.targetObj[key] = item;
      sendOnChange(value, item, key);
    };

    vm.tinyMceOptions = EditorConfig({
      contentLanguage: 'nl',
      inline: true,
      readonly: true
    });

  };

})();
